import { useCallback, useEffect, useState } from "react";
import { OpenMessage, LanguageNameSpaces } from "@shared/types";
import { useUser } from "@shared/utils/hooks/misc";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface useConnectDiscordProps {
  openMessage: OpenMessage;
  onSuccess?: () => void;
  isMobile?: boolean;
}

const useConnectDiscord = ({
  openMessage,
  onSuccess,
  isMobile,
}: useConnectDiscordProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.ONBOARDING);
  const { user, isFetching, refetch: refetchGetUser } = useUser();
  const [buttonClicked, setButtonClicked] = useState(false);

  useEffect(() => {
    if (buttonClicked && !isFetching) {
      if (!user?.is_discord_connected) {
        openMessage(t("external_account.discord.warning_message"), "warning");
      } else {
        openMessage(t("external_account.discord.success_message"), "success");
        onSuccess?.();
      }
    }
  }, [isFetching]);

  const onContinueClick = useCallback(() => {
    if (!buttonClicked) setButtonClicked(true);
    refetchGetUser();
  }, [buttonClicked]);

  return {
    onContinueClick,
    isFetching,
    discordBotLink: user?.discord_bot_url,
    botLink: `/connect_${isMobile ? "mobile" : "web"} ${user?.user_uuid}`,
    steps: [
      t("external_account.discord.step_1"),
      t("external_account.discord.step_2"),
      t("external_account.discord.step_3"),
    ],
  };
};

export default useConnectDiscord;
